import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { NotificationSettingsModel } from '../models/notification_settings_model';
import { INotificationSettingsCategory, IPreference, IUpdatedPreference } from '../notification_settings_interfacaes';
import { NotifyUserService } from '../services/notify_user_service';
angular
  .module('capability-ng-notification-settings')
  .factory(
    'updateAllNotificationSettingsCommand',
    function updateAllNotificationSettingsCommandDefinition(
      defineCommand: IDefineCommand,
      notificationSettingsModel: NotificationSettingsModel,
      updateNotificationSettingsCommand: ICommand,
      $http: ng.IHttpService,
      ngNotifyUserService: NotifyUserService,
      $q: ng.IQService
    ) {
      return defineCommand(
        'updateAllNotificationSettingsCommand',
        function updateAllNotificationSettingsCommand(deferred: any) {
          const settingsToUpdate = Array.from(notificationSettingsModel.trackedUpdates.values());
          const updatePromises = _4.map(settingsToUpdate, (newPreference) => {
            return updateNotificationSettingsCommand(
              newPreference.category_nk,
              newPreference.status,
              newPreference.preferenceType.key.toUpperCase()
            );
          });
          $q.all(updatePromises)
            .then((responses: Array<{ updatedCategory: INotificationSettingsCategory; channel: string }>) => {
              if (responses.length > 0) {
                const updatedCategories = responses.map((response) => response.updatedCategory);
                const successMessage = `Updated your preferences for categories: ${updatedCategories.join(', ')}`;
                ngNotifyUserService.notifySuccess(successMessage);
                notificationSettingsModel.resetTrackedUpdates();
              } else {
                const errorMessage = `No preference updates were selected: `;
                ngNotifyUserService.notifyError(errorMessage);
              }
              deferred.resolve();
            })
            .catch((responses: Array<{ updatePreference: INotificationSettingsCategory; channel: string }>) => {
              const message = responses.reduce((msg, response) => {
                return `${msg}
                    ${response.updatePreference}`;
              }, `Unable to update your preferences for categories:`);
              ngNotifyUserService.notifyError(message);
              notificationSettingsModel.resetTrackedUpdates();
              deferred.reject();
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/commands/update_all_notification_settings_command.ts